export const state = () => ({
  list: [],
  mainCategorie: { IdCategory: 200 },
  rowDisplay: 'full',
});

export const mutations = {
  init(state, list) {
    state.list = list;
  },
  setMainCategory(state, category) {
    state.mainCategorie = category;
  },
  setDisplayRow(state, rowDisplay) {
    state.rowDisplay = rowDisplay;
  },
};
